import React, { isValidElement, Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";

import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";

export default function KeyValue({ keyName, value, link, external }) {
  const linkParams = external
    ? {
      target: "_blank",
      href: link,
    }
    : { component: RouterLink, to: link };

  const innerComponent = (
    <Fragment>
      {isValidElement(value) ? (
        <Box style={{ paddingTop: 5 }}>{value}</Box>
      ) : (
        <Typography variant="caption" style={{ fontSize: 13 }}>
          {`${value}`}
        </Typography>
      )}
    </Fragment>
  );

  return (
    <Box style={{ margin: 5 }}>
      <Typography variant="caption" color="textSecondary">
        {keyName}
      </Typography>
      <Divider light />
      <Box style={{ fontSize: 13, marginLeft: 10, wordWrap: "anywhere" }}>
        {value !== null && value !== undefined ? (
          link ? (
            <Link color="inherit" underline="none" {...linkParams}>
              {innerComponent}
            </Link>
          ) : (
            innerComponent
          )
        ) : (
          <Typography
            variant="caption"
            color="textSecondary"
            style={{ fontSize: 13 }}
          >
            {"-"}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
